module.exports = ".card-night {\n   background-color: cornflowerblue;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/web/game/management/company-digest/date-digest/date-digest.component.css
// module id = ./src/app/web/game/management/company-digest/date-digest/date-digest.component.css
// module chunks = main